import type { EncryptedField, EncryptedPayload } from './types'

/** Bridges wire-format EncryptedField to internal EncryptedPayload for decryption. */
export const toEncryptedPayload = (
  field: EncryptedField,
  keyVersion: number,
): EncryptedPayload => ({
  encrypted: true,
  algorithm: 'AES-256-GCM',
  keyVersion,
  ciphertext: field.ciphertext,
  iv: field.iv,
})
